import { supabase } from "../supabaseClient";
import { logger } from "../utils/logger";

export async function fetchNames(groupId) {
  const [namesRes, countsRes] = await Promise.all([
    supabase
      .from("names")
      .select("id, name, user_id, created_at, is_child_list, relationship_label, relationship_custom_label")
      .eq("group_id", groupId)
      .order("created_at", { ascending: false }),
    supabase.rpc("group_list_counts", { p_group_id: groupId }),
  ]);

  if (namesRes.error) {
    logger.error('namesService', 'fetch_names_failed', { groupId, error: namesRes.error.message });
    throw namesRes.error;
  }
  if (countsRes.error) {
    logger.error('namesService', 'fetch_names_failed', { groupId, error: countsRes.error.message });
    throw countsRes.error;
  }

  const countsByListId = {};
  (countsRes.data || []).forEach((row) => {
    countsByListId[row.list_id] = { total: Number(row.total_items), claimed: Number(row.claimed_items) };
  });

  return (namesRes.data || []).map((n) => ({
    ...n,
    total_items: countsByListId[n.id]?.total ?? 0,
    claimed_items: countsByListId[n.id]?.claimed ?? 0,
  }));
}

export async function addName({ name, userId, groupId, isChildList, relationshipLabel, relationshipCustomLabel }) {
  const { data, error } = await supabase
    .from("names")
    .insert({
      name,
      user_id: userId,
      group_id: groupId,
      is_child_list: isChildList,
      relationship_label: relationshipLabel ?? null,
      relationship_custom_label: relationshipCustomLabel ?? null,
    })
    .select()
    .single();

  if (error) {
    logger.error('namesService', 'add_name_failed', { name, groupId, isChildList, relationshipLabel, relationshipCustomLabel, error: error.message });
    throw error;
  }
  logger.info('namesService', isChildList ? 'child_list_added' : 'name_added', { name, groupId, isChildList, relationshipLabel, relationshipCustomLabel });
  return data;
}

export async function renameName({ id, newName }) {
  const { data, error } = await supabase
    .from("names")
    .update({ name: newName })
    .eq("id", id)
    .select()
    .single();

  if (error) {
    logger.error('namesService', 'rename_name_failed', { nameId: id, newName, error: error.message });
    throw error;
  }
  logger.info('namesService', 'name_renamed', { nameId: id, newName });
  return data;
}

export async function deleteName({ id, name }) {
  const { error } = await supabase.from("names").delete().eq("id", id);

  if (error) {
    logger.error('namesService', 'delete_name_failed', { nameId: id, name, error: error.message });
    throw error;
  }
  logger.info('namesService', 'name_deleted', { nameId: id, name });
}
